<template>
  <div class="w-full">
    <div class="panel-head mb-4">
      <head-line :level="3" :size="3">{{ $t('general.dentists') }}</head-line>
      <p class="text-muted">{{ $t('pages.home.tabs.dentists.description') }}</p>
    </div>
    <form>
        <div class="md:flex items-center justify-start mb-2">
             <div class="inline-block w-full w-1/4 md:w-2/4 mb-4 md:mb-0" :class="[{'md:mr-3': !isRtl}, {'md:ml-3': isRtl}]">
                <input 
                v-model.trim="FilterString"
                class="shadow appearance-none border rounded w-full hover:border-awro-600 px-4 py-3 text-gray-700 leading-tight focus:outline-none focus:border-awro-600 transition-colors duration-100 ease-in" 
                id="doctorName" 
                type="text" 
                :placeholder="$t('form.placeholder.searchFilter')"
                >
              </div>
            
            <div class="inline-block w-full md:w-1/4 relative mb-4 md:mb-0" :class="[{'md:mr-3': !isRtl}, {'md:ml-3': isRtl}]">
              <select 
              v-model="CityId"
              class="block appearance-none w-full bg-white border border-gray-300 hover:border-awro-600 px-4 py-3 rounded shadow leading-tight focus:outline-none focus:border-awro-600 transition-colors duration-100 ease-in text-gray-500"
              :class="[{'pr-8': !isRtl}, {'pl-8': isRtl}]"
              name="cityId"
              id="cityId">
                <option disabled selected value="">{{ $t('form.field.city') }}</option>
                <option v-for="city in filters.Cities" :value="city.Id" :key="city.Id">{{city.Name }}</option>

              </select>
              <div class="pointer-events-none absolute inset-y-0  flex items-center px-2 text-gray-700" :class="[{'right-0': !isRtl}, {'left-0' : isRtl}]">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>

            <router-link :to="{
                name: 'SearchDentist',
                query: {FilterString, CityId, CenterType}
            }">
              <search-button class="w-full" :icon='true'></search-button>
            </router-link>

        </div> <!-- md:flex -->
    </form>
  </div>
</template>

<script>
import SearchButton from '@/components/SearchButton';
import HeadLine from '@/components/theme/HeadLine';
import {mapGetters} from 'vuex';

export default {
  name: 'DentistSearchPanel',
  components: {SearchButton, HeadLine},
  data() {
    return {
      FilterString: '',
      CityId: '',
      CenterType: 2
    }
  },
  created() {
    this.$store.dispatch('filters/FETCH_FILTERS');
  },
  computed: {
    ...mapGetters({
      isRtl: ['locale/IS_RTL'],
      filters: ['filters/FILTERS']
    })
  },
  watch: {
    '$i18n.locale': function () {
      this.$store.dispatch('filters/FETCH_FILTERS');
    }
  }
}
</script>

<style>

</style>
